var styleDataHash = 'b63697f1';  
export const injectCss = (() => {
  var css = `.g8WWV{color:var(--ricos-settings-action-color,var(--ricos-action-color,#116dff));height:18px;line-height:normal;pointer-events:auto;position:absolute;width:18px;z-index:10;fill:var(--ricos-settings-action-color,var(--ricos-action-color,#116dff))}[dir] .g8WWV{background-color:transparent;border:none;cursor:pointer;padding:0;text-align:center}[dir=ltr] .g8WWV{left:-10px;margin:3px 0 0 5px}[dir=rtl] .g8WWV{margin:3px 5px 0 0;right:-10px}[dir=ltr] .g8WWV.Xacu4{transform:rotate(45deg)}[dir=rtl] .g8WWV.Xacu4{transform:rotate(-45deg)}.g8WWV:hover{opacity:.7}[dir=ltr] .M3eS6{direction:ltr;left:-18px}[dir=ltr] .TSzpi,[dir=rtl] .M3eS6{direction:rtl;right:-18px}[dir=rtl] .TSzpi{direction:ltr;left:-18px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "sideToolbar_floatingIcon": "g8WWV",
  "sideToolbar_popupOpen": "Xacu4",
  "ltr": "M3eS6",
  "rtl": "TSzpi"
};